module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/may-bd978571e747b028f5a8043e9067a6d9.png";